/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    inserirConvenio(Convenio) {
        return axiosJwt.post(`${api}/convenios`, Convenio)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AlterarConvenio(Convenio) {
        return axiosJwt.post(`${api}/convenios/alterar`, Convenio)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirAcoes(acoes) {
        return axiosJwt.post(`${api}/convenios/InserirAcoes`, acoes)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirAditivo(aditivo) {
        return axiosJwt.post(`${api}/convenios/InserirAditivos`, aditivo)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirAplicacaoRecurso(Recurso) {
        return axiosJwt.post(`${api}/convenios/InserirAplicacaoRecursos`, Recurso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirCronogramaDesembolso(cronograma) {
        return axiosJwt.post(`${api}/convenios/InserirCronogramasDesembolsos`, cronograma)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AlterarCronogramaDesembolso(cronograma) {
        return axiosJwt.post(`${api}/convenios/AlterarCronogramasDesembolsos`, cronograma)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirRateioComprometimento(rateio) {
        return axiosJwt.post(`${api}/convenios/InserirRateioComprometimento`, rateio)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    InserirCronogramaRecebimento(cronograma) {
        return axiosJwt.post(`${api}/convenios/InserirCronogramaRecebimento`, cronograma)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AlterarCronogramaRecebimento(cronograma) {
        return axiosJwt.post(`${api}/convenios/AlterarCronogramaRecebimento`, cronograma)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ExcluirCronogramaRecebimento(idCronogramaRecebimento) {
        return axiosJwt
            .get(`${api}/convenios/DeletarCronogramaRecebimento/${idCronogramaRecebimento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPrestacaoContasMensal(prestacao) {
        return axiosJwt.post(`${api}/convenios/inserirPrestacaoContaMensal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirPrestacaoContasFinal(prestacao) {
        return axiosJwt.post(`${api}/convenios/InserirPrestacaoContasFinal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirDocumentosPrestacaoContasFinal(documento) {
        const formData = new FormData()
        formData.append('id_Documento', documento.id_Documento)
        formData.append('id_Convenio', documento.id_Convenio)
        formData.append('idPrestacaoContasFinal', documento.idPrestacaoContasFinal)
        formData.append('id_TipoDocumento', documento.id_TipoDocumento)
        formData.append('vcDescricaoDocumento', documento.vcDescricaoDocumento)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)

        return axiosJwt.post(`${api}/convenios/InserirDocumentoConvenio`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirDocumentosPrestacaoContasFinal(idDocumento) {
        return axiosJwt
            .get(`${api}/convenios/ExcluirDocumentoConvenio/${idDocumento}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterListaAplicacaoRecursos(idConvenio) {
        return axiosJwt
            .get(`${api}/convenios/ObterAplicacoesRecursos/${idConvenio}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterTodos() {
        return axiosJwt
            .get(`${api}/convenios`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterGestores() {
        return axiosJwt
            .get(`${api}/convenios/gestores`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/convenios/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNaturezas() {
        return axiosJwt
            .get(`${api}/convenios/naturezas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProjetosPorUnidade(vcCodUnidade) {
        return axiosJwt
            .get(`${api}/convenios/projetos/${vcCodUnidade}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoesPorProjeto(codProjeto) {
        return axiosJwt
            .get(`${api}/convenios/acoes/${codProjeto}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoesConvenio(idConvenio) {
        return axiosJwt
            .get(`${api}/convenios/ObterAcoesConvenio/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNaturezasPorAcao(idConvenio, idAcao) {
        return axiosJwt
            .get(`${api}/convenios/ListarNaturezasporAcao/${idConvenio}/${idAcao}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt
            .get(`${api}/convenios/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterConvenioDocumentoModelos(convenioId, tipoDocumento) {
        return axiosJwt
            .get(`${api}/convenios/${convenioId}/${tipoDocumento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadModelo(convenioId, modeloId, tipoDocumento) {
        return axiosJwt
            .get(
                `${api}/convenios/${convenioId}/${tipoDocumento}/modelo/${modeloId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    uploadModelo(convenioId, tipo, modelo, tipoDocumento) {
        const formData = new FormData()
        formData.append('convenioId', convenioId)
        formData.append('modeloId', modelo.modeloId)
        formData.append('arquivo', modelo.arquivo)

        return axiosJwt
            .post(
                `${api}/convenios/${convenioId}/${tipoDocumento}/modelo/${tipo}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumento(convenioId, modeloId, tipoDocumento) {
        return axiosJwt
            .get(
                `${api}/convenios/${convenioId}/${tipoDocumento}/documento/${modeloId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProcessosPorNumeroAta(numeroAta) {
        return axiosJwt.get(`${api}/convenios/obterprocessosatapornumeroata/${numeroAta}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterFornecedor(cnpjcpf) {
        return axiosJwt.get(`${api}/convenios/obterfornecedor/${cnpjcpf}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPrestacaoContaMensal(id) {
        return axiosJwt.get(`${api}/convenios/ObterPrestacaoContaMensal/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterDocumentosPrestacaoContaFinal(idPrestacaoFinal) {
        return axiosJwt.get(`${api}/convenios/ObterDocumentoConvenioPorIdPrestacaoFinal/${idPrestacaoFinal}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    glosarPrestacaoContasFinal(id) {
        return axiosJwt.get(`${api}/convenios/GlosarPrestacaoContasFinal/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    encerrarConvenio(id) {
        return axiosJwt.get(`${api}/convenios/EncerrarConvenio/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    // inserirDocumento(documento) {
    //     const formData = new FormData()
    //     formData.append('tipoDocumentoId', documento.tipoDocumentoId)
    //     formData.append('idContrato', documento.idContrato)
    //     formData.append('descricao', documento.descricao)
    //     formData.append('arquivo', documento.arquivo)
    //     formData.append('justificativaApostilamento', documento.justificativaApostilamento)
    //     formData.append('isApostilamento', documento.isApostilamento)

    //     return axiosJwt.post(`${api}/contratos/${documento.idContrato}/documentos`, formData, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data'
    //             }
    //         })
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    // excluirDocumento(documento) {
    //     return axiosJwt.put(`${api}/contratos/${documento.idContrato}/documentos/${documento.documentoContratoId}`, documento)
    //         .then((response) => {
    //             return response.data
    //         }).catch((error) => {
    //             return errorHandler(error)
    //         })
    // },

    obterDocumento() {
        return axiosJwt
            .get(`${api}/convenios/docx`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAplicacaoRecurso(idAplicacaoRecurso) {
        return axiosJwt
            .get(`${api}/convenios/deletaraplicacaorecurso/${idAplicacaoRecurso}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirCronogramaDesembolso(idCronogramaDesembolso) {
        return axiosJwt
            .get(`${api}/convenios/deletarcronogramadesembolso/${idCronogramaDesembolso}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirRateioComprometimento(idRateioComprometimento) {
        return axiosJwt
            .get(`${api}/convenios/deletarrateiocomprometimento/${idRateioComprometimento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirPrestacaoContaMensal(idPrestacaoContasMensal) {
        return axiosJwt
            .get(`${api}/convenios/deletarprestacaocontamensal/${idPrestacaoContasMensal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAcoes(id) {
        return axiosJwt
            .get(`${api}/convenios/DeletarAcoes/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAditivos(id) {
        return axiosJwt
            .get(`${api}/convenios/DeletarAditivo/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ativarAditivos(id) {
        return axiosJwt
            .get(`${api}/convenios/AtivarAditivo/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposConveniosRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterTiposConvenios`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterTipoProdutoFaturamentoRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterTipoProdutoFaturamento`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterTipoNaturezaRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterTipoNatureza`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterVendedoresRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterVendedores`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterRepresentantesRM() {
        return axiosJwt
            .get(`${api}/convenios/ObterRepresentantes`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    IntegrarConvenioRM(id) {
        return axiosJwt
            .get(`${api}/convenios/IntegrarConvenioRM/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioF02805DemonstrativoExecucaoSintetico(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/RelatorioF02805DemonstrativoExecucaoSintetico/${idConvenio}/${modelo}`, {
                responseType: 'blob'
            })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioF02806RelacaoPagamentosEfetuados(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/RelatorioF02806RelacaoPagamentosEfetuados/${idConvenio}/${modelo}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioF2807RelacaoPagamentosEfetuadosRecursosParceiro(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/RelatorioF2807RelacaoPagamentosEfetuadosRecursosParceiro/${idConvenio}/${modelo}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    RelatorioExtratoPrestacaoContas(idConvenio, modelo) {
        return axiosJwt
            .get(`${api}/convenios/RelatorioExtratoPrestacaoContas/${idConvenio}/${modelo}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    downloadDocumentoPrestacaoFinal(idDocumento) {
        return axiosJwt
            .get(
                `${api}/convenios/DownloadDocumentoPorId/${idDocumento}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarDocumentoPrestacaoContasConvenio(id) {
        return axiosJwt
            .get(`${api}/convenios/ListarDocumentoPrestacaoContasConvenio/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    DeletarDocumentoPrestacaoContasConvenio(obj) {
        return axiosJwt.post(`${api}/convenios/DeletarDocumentoPrestacaoContasConvenio`, obj)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    InserirDocumentoPrestacaoContasConvenio(obj) {
        return axiosJwt.post(`${api}/convenios/InserirDocumentoPrestacaoContasConvenio`, obj)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AlterarDocumentoPrestacaoContasConvenio(obj) {
        return axiosJwt.post(`${api}/convenios/AlterarDocumentoPrestacaoContasConvenio`, obj)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ListarDocumentoPrestacaoContas() {
        return axiosJwt
            .get(`${api}/convenios/ListarDocumentoPrestacaoContas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
